






import Vue from "vue";
import ResturantInfo from "@/views/dashboard/ResturantInfo.vue";
import ResturantMenu from "@/views/dashboard/ResturantMenu.vue";
import { GET_MENU } from "@/queries/user/query.graphql";

console.log(ResturantInfo);

export default Vue.extend({
  data() {
    return {
      menu: null
    };
  },
  components: {
    ResturantInfo,
    ResturantMenu
  },
  apollo: {
    menu: {
      query: GET_MENU,
      update(data) {
        this.$store.commit("userModule/setMenu", data.Menu[0]);
        return data.Menu[0];
      },
      result() {
        console.log(this.$refs.xx);
      }
    }
  }
});
